'use strict';

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Drawer = function Drawer(_ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      closeCb = _ref.closeCb,
      drawerOpen = _ref.drawerOpen,
      theme = _ref.theme,
      onRight = _ref.onRight,
      preventScroll = _ref.preventScroll,
      showClose = _ref.showClose,
      swipeToClose = _ref.swipeToClose; // change docked position

  var positionStyle = {};
  if (onRight === true) positionStyle = {
    left: 'inherit',
    right: 0
  }; // stop the body from being scrollable

  setTimeout(function () {
    if (window.document && preventScroll === true && drawerOpen === true) {
      window.document.getElementsByTagName('html')[0].className += ' nwc--noscroll';
    } else {
      window.document.getElementsByTagName('html')[0].className -= ' nwc--noscroll';
    }
  }, 3000); // swipe detection :: https://stackoverflow.com/questions/2264072/detect-a-finger-swipe-through-javascript-on-the-iphone-and-android

  if (swipeToClose === true && drawerOpen) {
    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);
  }

  var xDown = null;
  var yDown = null;

  function getTouches(e) {
    return e.touches;
  }

  function handleTouchStart(e) {
    var firstTouch = getTouches(e)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
    console.log('handleTouchStart');
  }

  ;

  function handleTouchMove(evt) {
    if (!xDown || !yDown || drawerOpen !== true) return;
    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;
    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        // left swipe
        // console.log('left');
        if (onRight !== true) closeCb();
      } else {
        // right swipe
        // console.log('right');
        if (onRight === true) closeCb();
      }
    } else {
      if (yDiff > 0) {
        console.log('up'); // up swipe
      } else {
        console.log('down'); // down swipe
      }
    } // reset values


    xDown = null;
    yDown = null;
  }

  ;
  return _react2["default"].createElement('nav', {
    className: drawerOpen === true ? 'nwc--drawer ' + theme : 'nwc--drawer closed ' + theme,
    style: _extends({}, positionStyle)
  }, _react2["default"].createElement('section', {
    style: {
      backgroundColor: backgroundColor
    }
  }, showClose === true && _react2["default"].createElement('div', {
    role: 'button',
    className: 'nwc--drawer-close padding--sm text--right font--28 border--bottom',
    onClick: function onClick() {
      return closeCb();
    }
  }, '\xD7\xA0\xA0'), children), _react2["default"].createElement('aside', {
    className: 'nwc--drawer-mask',
    onClick: function onClick() {
      return closeCb();
    }
  }));
};

Drawer.defaultProps = {
  backgroundColor: '',
  closeCb: function closeCb() {
    return null;
  },
  drawerOpen: false,
  theme: '',
  onRight: false,
  showClose: false,
  swipeToClose: false
};
Drawer.propTypes = {
  backgroundColor: _propTypes.PropTypes.string,
  children: _propTypes.PropTypes.object.isRequired,
  closeCb: _propTypes.PropTypes.func,
  drawerOpen: _propTypes.PropTypes.bool,
  theme: _propTypes.PropTypes.string,
  onRight: _propTypes.PropTypes.bool,
  showClose: _propTypes.PropTypes.bool,
  swipeToClose: _propTypes.PropTypes.bool
};
exports["default"] = Drawer;